<template>
  <v-dialog v-model="showSourcesDialog" max-width="700" @close="closeSources">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="10">
            <span class="text-h6">Add Sources</span>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-btn icon @click="closeSources">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="py-1">
            <v-text-field v-model="search" clearable dense hide-details label="Search Container Options" outlined
              prepend-inner-icon="mdi-magnify"></v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex justify-end pa-0  py-1">
            <v-col cols="2 pe-4 pa-0">
              <v-icon @click="addSource" :disabled="this.clickedAddSource" class="float-right"
                color="primary">mdi-plus</v-icon>
            </v-col>
          </v-col>
          <v-col cols="12">
            <v-data-table :headers="headers" :items="sources" :search="search" dense mobile-breakpoint="700"
              no-data-text="No sources available" class="elevation-1">
              <template v-slot:item.source_name="{ item }">
                <div v-if="selectedSource && selectedSource.id === item.id" class="pa-0">
                  <transition name="expand">
                    <v-text-field class="pa-0" v-model="item.source_name" underlined dense small />
                  </transition>
                </div>
                <div v-else>
                  {{ item.source_name }}
                </div>
              </template>
              <template v-slot:item.token_required="{ item }">
                <v-chip class="text-center" small :color="item.token_required ? 'green' : 'red'" dark
                  style="width: 42px;" @click="toggleTokenRequired(item)">
                  {{ item.token_required ? 'Yes' : 'No' }}
                </v-chip>
              </template>
              <template v-slot:item.color="{ item }">
                <v-avatar size="24" :color="item.color || 'black'" :style="{
                  cursor: selectedSource && selectedSource.id === item.id ? 'pointer' : 'not-allowed',
                  opacity: selectedSource && selectedSource.id === item.id ? 1 : 0.6
                }" @click="selectedSource && selectedSource.id === item.id ? handleAvatarClick(item) : null">
                </v-avatar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn v-if="!selectedSource || selectedSource.id !== item.id" icon @click="editSource(item)">
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="primary" v-else @click="saveSource(item)">
                  <v-icon color="primary">mdi-check</v-icon>
                </v-btn>
                <v-btn icon @click="deleteSource(item)">
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <v-dialog v-model="showColorPickerForItem" max-width="290" persistent>
                  <v-card>
                    <v-card-title>Pick a Color</v-card-title>
                    <v-card-text class="pa-0">
                      <v-color-picker v-model="selectedColor" dot-size="8" mode="hexa" hide-mode-switch
                        swatches-max-height="100">
                      </v-color-picker>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end pa-1">
                      <v-btn small color="error" @click="showColorPickerForItem = false">Cancel</v-btn>
                      <v-btn small color="primary" @click="applyColor">Select</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from 'sweetalert2'
import { apiService } from '../../service/api.service'

export default {
  data () {
    return {
      headers: [
        { text: 'Source Name', value: 'source_name', align: 'start', sortable: true },
        { text: 'Token Required', value: 'token_required', align: 'center', sortable: false },
        { text: 'Color', value: 'color', align: 'center', sortable: false },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      selectedSource: null,
      search: '',
      showColorPickerForItem: false,
      selectedColor: null,
      clickedAddSource: false,
      sources: []
    }
  },
  props: {
    showSourcesDialog: Boolean
  },
  methods: {
    editSource (item) {
      this.selectedSource = item
    },
    toggleTokenRequired (item) {
      this.selectedSource.token_required = !item.token_required
    },
    closeSources () {
      this.showColorPickerForItem = false
      this.$emit('close-sources')
    },
    handleAvatarClick (item) {
      if (this.selectedSource && this.selectedSource.id === item.id) {
        this.selectedColor = item.color
        this.showColorPickerForItem = true
      } else {
        this.selectedSource = item
        this.selectedColor = item.color
        this.showColorPickerForItem = true
      }
    },
    saveSource (item) {
      if (!item.id) {
        apiService
          .post('admin/docker-sources', {
            name: item.source_name,
            tokenRequired: item.token_required,
            color: item.color
          })
          .then(() => {
            Swal.fire('Success!', 'Source added.', 'success')
          })
          .catch((err) => {
            Swal.showValidationMessage(`Request failed: ${err}`)
          })
      } else {
        apiService
          .put(`admin/docker-sources/${item.id}`, {
            name: item.source_name,
            tokenRequired: item.token_required,
            color: item.color
          })
          .then(() => {
            Swal.fire('Success!', 'Source updated.', 'success')
          })
          .catch((err) => {
            Swal.showValidationMessage(`Request failed: ${err}`)
          })
      }
      this.selectedSource = null
      this.showColorPickerForItem = false
      this.selectedColor = null
      this.clickedAddSource = false
      this.getSources()
    },
    addSource () {
      this.clickedAddSource = true
      this.selectedSource = {
        source_name: '',
        token_required: false,
        color: '#000000'
      }
      this.sources.push(this.selectedSource)
    },
    deleteSource (item) {
      if (item.id) {
        Swal.fire({
          title: 'Are you sure?',
          text: 'You want to delete this source?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.isConfirmed) {
            apiService
              .delete(`admin/docker-sources/${item.id}`)
              .then((res) => {
                Swal.fire('Success!', 'Source deleted.', 'success')
                this.getSources()
              })
              .catch((err) => {
                Swal.showValidationMessage(`Request failed: ${err}`)
                this.getSources()
              })
          }
        })
      } else {
        this.getSources()
      }
      this.selectedSource = null
      this.showColorPickerForItem = false
      this.clickedAddSource = false
    },
    getSources () {
      apiService.get('/admin/docker-sources')
        .then(response => {
          this.sources = response.data.docker_sources
        })
        .catch(error => {
          console.log(error)
        })
    },
    applyColor () {
      if (this.selectedSource && this.selectedColor) {
        this.selectedSource.color = this.selectedColor
      }
      this.showColorPickerForItem = false
    }

  },
  watch: {
    selectedColor (val) {
      if (this.selectedSource && val) {
        this.selectedSource.color = typeof val === 'string' ? val : val.hex
      }
    }
  },
  async mounted () {
    await this.getSources()
  },
  beforeDestroy () {
    this.showColorPickerForItem = false
    this.selectedColor = null
    this.clickedAddSource = false
    this.sources = []
  }

}
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease-in-out;
}

.expand-enter,
.expand-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>
